

define(['angular', 'squid/index', 'text!./template.html', 'components/xo-models/src/fi/index', 'components/xo-models/src/checkout/index', 'components/xo-models/src/auth/index', '../bank-input/directive', 'components/xo-ui-components/src/message/directive', 'components/xo-ui-components/src/popup/directive', 'components/xo-tray-height/dist/directive', 'components/xo-page-components/src/aside-header/directive', 'components/xo-ui-components/src/error-tooltip/directive', '../../fi-contingency-list/util'], function (angular, squid, template) {

    return squid.module('xo-add-bank.addbank.directive', ['squid', 'xomodel.fi', 'xomodel.checkout', 'xomodel.auth', 'xo-add-bank.bank-input.directive', 'xo-message.directive', 'xo-popup.directive', 'xo-tray-height.directive', 'xo-aside-header.directive', 'xo-error-tooltip.directive', 'fi.errorUtil']).directive('xoAddBank', function () {
        return {
            template: template,

            scope: {
                parentCallbacks: '=',
                errorMessage: '=',
                bank: '=',
                sidebar: '=',
                hideparenthead: '=',
                message: '=',
                pageLevel: '='
            },

            controller: function controller($scope, $populate, $AddBankModel, $BillingAddressesModel, $AuthModel, $element, $locale, $fiErrorUtil) {
                $scope.model = $scope.bank || new $AddBankModel({
                    id: 123
                });

                $scope.locale = $locale;

                if ($scope.hideparenthead) {
                    $scope.hideparenthead.toggle = false;
                }

                $scope.onSubmit = function () {
                    if ($scope.pageLevel) {
                        $scope.pageLevel.message = null;
                    }

                    var data = $scope.model.getBankData();

                    function mapValidationErrors(err) {
                        var fields = err && err.fields || [];
                        fields.forEach(function (fieldError) {
                            if (fieldError && fieldError.property) {
                                fieldError.field = fieldError.property;
                            }
                        });
                        return {
                            fields: fields
                        };
                    }

                    $scope.model.action('validate', {

                        data: data,

                        resultModel: {},

                        success: function success(successData) {
                            $scope.model.creditorDetails = successData.creditorDetails;
                            $scope.model.fiDetails = successData.fiDetails;
                            $scope.parentCallbacks.addBankDone($scope.model);
                        },

                        contingencies: {
                            VALIDATE_BANK_CONTINGENCY: function VALIDATE_BANK_CONTINGENCY(name, contingencyData) {
                                $scope.errorMessage = $fiErrorUtil.addPageErrors(contingencyData, 'bank');
                                $fiErrorUtil.addFieldErrors(contingencyData, $element, 'model.');
                            }
                        },
                        validation: function validation(res) {
                            $fiErrorUtil.addFieldErrors(mapValidationErrors(res), $element, 'model.');
                        }
                    });
                };

                $populate($scope, {
                    auth: $AuthModel.instance(),
                    billingAddresses: $BillingAddressesModel.instance()

                }).then(function () {

                    $scope.model.address = $scope.billingAddresses.addresses && $scope.billingAddresses.addresses[0];

                    $scope.model.user.first_name = $scope.auth.first_name;
                    $scope.model.user.last_name = $scope.auth.last_name;
                    $scope.model.user.country = $scope.model.address && $scope.model.address.country;
                });
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-wallet-components/src/add-bank/addbank/directive.js
 ** module id = 253
 ** module chunks = 1
 **/